/**
 * Every section the dialog can report, in the order they are displayed.
 * See README.md to add a property or a section.
 */
import ruleLabelsConfig from "./ruleLabels";
import actionStepConfig from "./actionStep";
import actionFilterConfig from "./actionFilter";
import targetStepConfig from "./targetStep";
import targetFilterConfig from "./targetFilter";
import cloudStorageConfig from "./cloudStorage";
import storageFilepathConfig from "./storageFilepath";
import storageActionsConfig from "./storageActions";
import sendDelayConfig from "./sendDelay";
import approvalStepsConfig from "./approvalSteps";
import smimeActionsConfig from "./smimeActions";

import { SectionConfig } from "../../types";

export const sectionConfigs: SectionConfig[] = [
  ruleLabelsConfig,
  actionStepConfig,
  actionFilterConfig,
  targetStepConfig,
  targetFilterConfig,
  cloudStorageConfig,
  storageFilepathConfig,
  storageActionsConfig,
  sendDelayConfig,
  approvalStepsConfig,
  smimeActionsConfig,
];
